import * as dayjs from "dayjs";

export const calculateInstallmentDates = (installmentAmount: number, dueDate: Date): Date[] => {
    const payments = [dueDate];
    let paymentDate: dayjs.Dayjs = dayjs(dueDate);

    for (let currentInstallment = 1; currentInstallment < installmentAmount; currentInstallment++) {
        payments.push(paymentDate.add(currentInstallment, 'month').toDate());
    }

    return payments;
}